import {Turbo} from "@hotwired/turbo-rails"
// TODO: Enable turbo for all pages later
Turbo.session.drive = false

import "../controllers/index"
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap
import 'bootstrap-icons/font/bootstrap-icons.css'

import '../sneat/menu'
import '../sneat/bootstrap'
import '../sneat/config'
import '../sneat/helpers'
import '../sneat/main'

import 'apexcharts-clevision/dist/apexcharts.min'
import '../sneat/dashboards-analytics'
import "trix"
import "@rails/actiontext"
